import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { colorPalette } from '../../colorPalette';
import { ListBlockOptions } from './constant';
import Check from '@material-ui/icons/Check';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
export const ListBlock = ({ title, list, listOption, iconColor = 'gray1000' }) => {
    const useStyles = makeStyles({
        title: {
            color: colorPalette.gray400,
            fontWeight: 600,
            fontSize: '14px',
            lineHeight: '18px',
        },
        element: {
            color: colorPalette.gray800,
            fontSize: '14px',
            lineHeight: '18px',
            marginBottom: '6px',
        },
        liCheck: {
            display: 'flex',
            alignItems: 'center',
            listStyleType: 'disc',
        },
        liCircle: {
            display: 'flex',
            alignItems: 'center',
            listStyleType: 'disc',
        },
        liPoint: { listStyleType: 'disc' },
        point: { margin: '14px 0', paddingLeft: '25px' },
        check: { listStyle: 'none', margin: '14px 0', padding: '0' },
        circle: { counterReset: 'section', listStyle: 'none', margin: '14px 0', padding: '0' },
        liClass: {
            display: 'flex',
        },
        mr8: { margin: '0 8px 0 0' },
        mt2: { marginTop: '2px' },
        checkCircleMargin: { marginLeft: '8px' },
        'circle:before': {
            content: 'counter(section)',
            counterIncrement: 'section',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: '16px',
            minHeight: '16px',
            margin: '0 8px 0 0',
            border: `1px solid ${colorPalette.red800}`,
            borderRadius: '100%',
            textAlign: 'center',
            color: colorPalette.red800,
            fontWeight: 600,
            fontSize: '9px',
            lineHeight: '11px',
        },
    });
    const s = useStyles();
    let ulClassName;
    switch (listOption) {
        case ListBlockOptions.NUMBER:
            ulClassName = s.circle;
            break;
        case ListBlockOptions.CHECK:
            ulClassName = s.check;
            break;
        case ListBlockOptions.CHECK_CIRCLE:
            ulClassName = s.check;
            break;
        case ListBlockOptions.CHECK_CIRCLE_OUTLINED:
            ulClassName = s.check;
            break;
        default:
            ulClassName = s.point;
    }
    const liClassNames = [s.liClass];
    if (listOption === ListBlockOptions.NUMBER) {
        liClassNames.push(s.circle);
    }
    const checkCircleMargin = listOption === ListBlockOptions.CHECK_CIRCLE || listOption === ListBlockOptions.CHECK_CIRCLE_OUTLINED ? s.checkCircleMargin : '';
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: s.title }, title),
        React.createElement("ul", { className: ulClassName }, list &&
            list.map((element) => (
            // eslint-disable-next-line react/jsx-key
            React.createElement("div", { className: s.element },
                React.createElement("li", { className: liClassNames.join(' ') },
                    listOption === ListBlockOptions.CHECK && React.createElement(Check, { className: s.mr8, style: { color: colorPalette[iconColor] } }),
                    listOption === ListBlockOptions.CHECK_CIRCLE && (React.createElement(CheckCircleIcon, { className: s.mt2, style: { color: colorPalette[iconColor] } })),
                    listOption === ListBlockOptions.CHECK_CIRCLE_OUTLINED && (React.createElement(CheckCircleOutlineIcon, { style: { fontSize: '16px', marginTop: '2px', color: colorPalette[iconColor] } })),
                    React.createElement("span", { className: checkCircleMargin }, element))))))));
};
